import { render, staticRenderFns } from "./ui-button-message.vue?vue&type=template&id=162de738&scoped=true"
import script from "./ui-button-message.vue?vue&type=script&lang=js"
export * from "./ui-button-message.vue?vue&type=script&lang=js"
import style0 from "./ui-button-message.vue?vue&type=style&index=0&id=162de738&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162de738",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('162de738')) {
      api.createRecord('162de738', component.options)
    } else {
      api.reload('162de738', component.options)
    }
    module.hot.accept("./ui-button-message.vue?vue&type=template&id=162de738&scoped=true", function () {
      api.rerender('162de738', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/button/ui-button-message.vue"
export default component.exports